import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

export const getReportingStatusListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_REPORTING_STATUSES}?${stringifyParams(
			params
		)}`
	);
};

export const getReportingStatusList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		// populate: ['creation_user', 'modification_user'],
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_REPORTING_STATUSES}?${stringifyParams(
			queryParams
		)}`
	);
};

export const getReportingStatus = reporting_status_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_REPORTING_STATUS}${reporting_status_id}`
	);
};

export const addNewReportingStatusApi = reporting_status => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_REPORTING_STATUS}`,
		reporting_status
	);
};

export const updateReportingStatusApi = reporting_status => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_REPORTING_STATUS}${reporting_status._id}`,
		reporting_status
	);
};

export const deleteReportingStatusApi = reporting_status_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_REPORTING_STATUS}${reporting_status_id}`
	);
};

export const checkReportingStatusExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_REPORTING_STATUS_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
